export const showStarsNSuper = true;
// Let everyone see dashboard
export const letLemmingsIn = false || process.env.NODE_ENV !== 'production';
